<script>
import {chemicalApi} from "@/api/chemical";

export default {
  name: 'ChemInfoList',
  data(){
    return {
      infoList: [],
      queryParam : {},
      current: 1,
      size: 20,
      total : 0,

    }
  },
  mounted() {
    this.fetchInfoList();
  },
  methods : {
    async fetchInfoList() {
      const param = {
        current: this.current,
        size: this.size,
        ...this.queryParam
      }
      const res = await chemicalApi.pageChemicalList(param)
      if (res.code === '0000'){
        this.infoList = res.result.records
        this.total = res.result.total
      }
    },
    handleQuery(){
      this.fetchInfoList()
    },
    handleDetail(row){
      this.$router.push({
        path: `/chemInfo/detail/${row.id}`
      })
    },
    handleSizeChange(val) {
      this.current = val;
      this.fetchInfoList()
    },
    handleCurrentChange(val) {
      this.current = val;
      this.fetchInfoList()
    },
  },
}
</script>

<template>
  <div>
    <el-card >
      <template #header>
        <div style="display: flex; align-items: center; justify-content: space-between;">
          <div style="display: flex; align-items: center;">
             <el-form label-width="90px" style="display: flex">
               <el-form-item label="CAS编号" prop="casNo">
                 <el-input v-model="queryParam.casNo" />
               </el-form-item>
               <el-form-item label="危化品名称" prop="chemName">
                 <el-input v-model="queryParam.chemName" />
               </el-form-item>
             </el-form>
          </div>
          <el-button type="primary" size="small" icon="el-icon-search" @click="handleQuery">查询</el-button>
        </div>
      </template>
      <el-table :data="infoList" border  stripe highlight-current-row>
        <el-table-column label="化学品名称" prop="chemName"  />
        <el-table-column label="CAS编号" prop="chemCas" />
        <el-table-column label="化学品别名" prop="chemAlias" />
        <el-table-column label="英文名称" prop="chemEnglishName" />
        <el-table-column label="操作" fixed="right" width="80">
          <template slot-scope="scope">
            <el-button type="text" size="mini" @click="handleDetail(scope.row)">详情</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                     :current-page="current" :page-sizes="[10, 20, 50, 100]" :page-size="size"
                     layout="total, sizes, prev, pager, next, jumper" :total="total"
                     class="pagination"/>
    </el-card>
  </div>
</template>

<style scoped>

</style>
